import { render, staticRenderFns } from "./territory.vue?vue&type=template&id=5a0d4be1"
import script from "./territory.vue?vue&type=script&lang=js"
export * from "./territory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports